import type { DatasetDependency } from '../dataset-controller/dependencyManager'
import type { AdaptedComponent } from '../inverted-dependencies/components'
import { repeaterUtilsFactory } from './repeaterUtils'

interface Config {
  builder: boolean
  datasetId: string
  connectionsGraph: Record<string, string[]>
  datasetIsReal: boolean
  getDependencies: () => DatasetDependency[]
}

export const getComponentsToDatabind = (
  components: AdaptedComponent[],
  { builder, datasetId, connectionsGraph, datasetIsReal, getDependencies }: Config,
) => {
  if (builder || !datasetIsReal) {
    return components
  }

  const { isInsidePrimaryOrDetailsRepeater, getDetailsRepeaters } =
    repeaterUtilsFactory({
      datasetId,
      connectionsGraph,
      masterIds: getDependencies().map(
        dependency => dependency.masterDatasetId,
      ),
    })

  const componentsToDatabind = components.filter(
    component => !isInsidePrimaryOrDetailsRepeater(component),
  )

  componentsToDatabind.push(...getDetailsRepeaters(components))

  return componentsToDatabind
}
